<script>
import locale, {lang} from "../localize/localize.js";
export default {
  name: "Result",
  inject: ['store'],
  computed: {
    discounted_monthly_installment: function () {
      if (this.store.Response.discounted_monthly_installment) {
        return this.store.Response.discounted_monthly_installment.toLocaleString()?.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") ;
      } else {
        return ""
      }
    },
    saved_amount: function () {
      if (this.store.Response.result?.saved_amount) {
        return this.store.Response.result?.saved_amount.toLocaleString()?.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return ""
      }
    },
    monthly_limit: function () {
      if (this.store.Response.monthly_limit) {
        return this.store.Response.monthly_limit.toLocaleString();
      } else {
        return ""
      }
    },
    calcTenor :function () {
      let tenor;
      this.store.calcFields.map((resetter) => {
        const fieldID = resetter.id;
        if(fieldID == 'tenor'){
          resetter.options.filter(op=>{
            if(op.value == this.store.calcModel['tenor']){
              tenor = op.label;
            }
          })
        }
      });
      // console.log({...this.store})
      // console.log(tenor)
      return tenor;
    }
  },
  methods: {
    locale(value) {
      return locale(value)
    },
    scrollToApplyForm() {
      window.requestAnimationFrame(() => {
        document.querySelector('#AgricoleForm' + this.store.productItem)?.scrollIntoView({ behavior: "smooth", block: "start" });
        if(window.toggleFormV){
          window.toggleFormV(this.store.productItem)
        }
      });

      // console.log(this.calcTenor)
    }
  }
}
</script>
<template>
  <div class="loan-calc-result">
    <div>
      <h2> {{ store.calcTitles.result_title }} </h2>

      <div class="calc-res">
        <template v-if="store.Response">
          <template v-if="Object.keys(store.Response).length > 0">
            <template v-if="discounted_monthly_installment">
              <b> {{ store.calcTitles.currency }} {{ discounted_monthly_installment }} </b>
            </template>

            <!-- <template v-if="saved_amount">
              <b> {{ store.calcTitles.currency }} {{ saved_amount }} </b>
              <span>Interest Rate</span>
              <br/>
            </template>
            -->
            <template v-if="store.Response.result?.interest_rate">
              <b> {{ store.Response.result?.interest_rate }}% </b>
              <span>{{locale('Interest Rate')}}</span>
              <br/>
            </template>

            <template v-if="store.Response.result?.total_amount">
              <b> {{ store.calcTitles.currency }} {{ store.Response.result?.total_amount?.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} </b>
              <span>{{locale('Amount Maturity')}}</span>
              <span>({{locale('After')}} {{calcTenor}})</span>
              <br/>
            </template>

            <template v-if="store.Response.result?.interest">
              <b> {{ store.calcTitles.currency }} {{ store.Response.result?.interest?.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")  }} </b>
              <span>{{locale('Interest')}}</span>
              <br/>
            </template>


          </template>

          <template v-if="store.Response?.monthly_limit > 0">
            <span class="red mt-3"> {{ store.Response.limit_msg }} </span>
              <p></p>
          </template>
          <!-- mathcing live behaviour -->
          <!-- <span class="red mt-3" v-if="store.Response?.qualified"> {{ store.Response.unqualified_msg }} </span> -->
        </template>
      </div>

      <p class="disclaimer">{{ store.calcTitles.disclaimer }}</p>
      <p class="response_disclaimer">{{ store.Response?.disclaimer }}</p>
    </div>
    <button @click="scrollToApplyForm" class="btn btn-primary w-100"> {{ store.calcTitles.form_button }} </button>
  </div>
</template>